import { getPublicFreeDeal } from "./PublicFreeDealService";
import { getPublicDealPreview } from "./PublicPreviewService";

// One cache entry per ZIP + chain for the two public clearance endpoints, shared by
// the home page, /clearance and the daily spotlight. The API allows 12 of these calls
// per 10 minutes per visitor, so every surface reads the same entries.

const STALE_MS = 10 * 60_000;

/** Nearby clearance count (`totalDeals`) plus the one fully unlocked deal. */
export function publicFreeDealQuery(zip: string, chain: string) {
  return {
    queryKey: ["public-free-deal", zip, chain] as const,
    queryFn: () => getPublicFreeDeal(zip, chain),
    staleTime: STALE_MS,
    retry: 0,
  };
}

/** Up to six nearby clearance finds (name, photo, discount band; no prices). */
export function publicDealPreviewQuery(zip: string, chain: string) {
  return {
    queryKey: ["public-deal-preview", zip, chain] as const,
    queryFn: () => getPublicDealPreview(zip, chain),
    staleTime: STALE_MS,
    retry: 0,
  };
}

/** Chains with public in-store clearance, in the order the Clearance page lists them. */
export const CLEARANCE_CHAINS = ["walmart", "target", "bestbuy", "costco", "home_depot", "dollar_general"] as const;
export type ClearanceChain = (typeof CLEARANCE_CHAINS)[number];

/** "70%+ off" → "70%+": the badge already sits on a discount. */
export function bandBadge(band: string): string {
  return band.replace(/\s*off$/i, "");
}
